const translation = {
	helloWorld: "Hallo, verden!"
} as const;

export default translation;
